import React, { Fragment, useState } from 'react';
import PropTypes from 'prop-types';
import { Row, Col, Button } from 'reactstrap';
import Select from 'react-select';
// import DatePicker from 'react-datepicker';
import moment from 'moment';
import { useLazyQuery } from 'react-apollo';
import SelectCountry from './SelectCoutry';
import { GET_BOOKING_CHARGES } from '../queries';
import { APP_NAME } from '../constants';

const styles = {
  docName: {
    fontWeight: 'bold'
  },
  docSpl: {
    color: '#808080',
    textTransform: 'capitalize'
  },
  stDate: {
    fontWeight: 'bold'
  },
  topMargin: {
    marginTop: 10
  },
  slotHeader: {
    fontWeight: 'bold',
    fontSize: 12,
    textAlign: 'center',
    backgroundColor: '#b3b3b3',
    border: '1px solid #fff'
  },
  dayContainer: {
    border: '1px solid #c7c7c7',
    textAlign: 'center'
  },
  slotContainer: {
    borderTop: '1px solid #c7c7c7'
  },
  formLabel: {
    fontWeight: 'bold',
    display: 'flex',
    justifyContent: 'flex-end'
  },
  actionButton: {
    width: '210px'
  },
  errorText: {
    fontSize: '14px',
    color: 'red',
    marginTop: '8px'
  },
  feeText: {
    fontSize: '14px',
    color: '#374151',
    marginTop: '8px'
  }
};

const guardianRelOpts = [
  'Father',
  'Mother',
  'Brother',
  'Sister',
  'Extended Family',
  'Grandparent'
].map(r => ({ label: r, value: r }));

const ApptBookingLongForm = props => {
  // console.log('props', props);
  const {
    isNewPatient,
    hasMPI,
    bookingData,
    onChange,
    onSubmit,
    hospitalId,
    doctorId,
    selectedSlot,
    procedureName,
    isScanBooking
  } = props;
  const {
    userName,
    userCountry,
    userMobile,
    userEmail,
    // userGender,
    guardianName,
    userDoB,
    mpid
  } = bookingData || {};

  const [appointmentFee, setAppointmentFee] = useState(null);
  const [chargeError, setChargeError] = useState(null);

  const [fetchBookingCharges, { loading: loadingCharges }] = useLazyQuery(
    GET_BOOKING_CHARGES,
    {
      fetchPolicy: 'network-only',
      onCompleted: ({ getBookingCharges }) => {
        if (getBookingCharges) {
          setAppointmentFee(getBookingCharges.totalPayable);
          setChargeError(null);
        }
      },
      onError: error => {
        setAppointmentFee(null);
        const errorMessage = (
          error.message || 'Failed to calculate charges'
        ).replace('GraphQL error: ', '');
        setChargeError(errorMessage);
      }
    }
  );

  const handleCalculateFee = () => {
    const slotTime =
      selectedSlot && selectedSlot.startTime
        ? moment(selectedSlot.startTime).toISOString()
        : '';

    const variables = {
      input: {
        hospitalId: hospitalId ? String(hospitalId) : '',
        serviceType: procedureName || '',
        mpid: mpid || '',
        doctorId,
        slotTime
      }
    };

    setChargeError(null);
    setAppointmentFee(null);
    fetchBookingCharges({ variables });
  };

  // let userGenderOpt;
  // if (userGender) {
  //   userGenderOpt = { label: userGender, value: userGender };
  // }

  let showGuardian = false;

  if (userDoB && moment().diff(moment(userDoB), 'years') < 18) {
    showGuardian = true;
  }

  // console.log(`show g ${showGuardian}`);

  return (
    <React.Fragment>
      <Row className="form-row">
        <Col xs={4} className="text-right" style={styles.formLabel}>
          Mobile<div style={{ color: 'red' }}>*</div>:
        </Col>
        <Col xs={8}>
          <input
            onChange={e => onChange('userMobile', e.target.value)}
            readOnly
            defaultValue={userMobile}
          />
        </Col>
      </Row>
      <Row className="form-row">
        <Col xs={4} className="text-right" style={styles.formLabel}>
          Patient Name<div style={{ color: 'red' }}>*</div>:
        </Col>
        <Col xs={8}>
          <input
            onChange={e => onChange('userName', e.target.value)}
            readOnly={!isNewPatient}
            defaultValue={userName}
          />
        </Col>
      </Row>
      {!hasMPI && (
        <Fragment>
          <Row className="form-row">
            <Col xs={4} className="text-right" style={styles.formLabel}>
              Nationality:
            </Col>
            <Col xs={8}>
              <SelectCountry
                isSearchable
                defaultValue={userCountry}
                onChange={v => onChange('userCountry', v)}
              />
            </Col>
          </Row>
          <Row className="form-row">
            <Col xs={4} className="text-right" style={styles.formLabel}>
              Email:
            </Col>
            <Col xs={8}>
              <input
                onChange={e => onChange('userEmail', e.target.value)}
                defaultValue={userEmail}
              />
            </Col>
          </Row>
          {/* <Row className="form-row">
            <Col xs={4} className="text-right" style={styles.formLabel}>
              Gender:
            </Col>
            <Col xs={8}>
              <Select
                value={userGenderOpt}
                onChange={v => onChange('userGender', v.value)}
                options={[
                  { label: 'Female', value: 'Female' },
                  { label: 'Male', value: 'Male' }
                ]}
              />
            </Col>
          </Row>
          <Row className="form-row">
            <Col xs={4} className="text-right" style={styles.formLabel}>
              Date of Birth (DD/MM/YYYY):
            </Col>
            <Col xs={8}>
              <DatePicker
                selected={userDoB}
                maxDate={moment()}
                dateFormat="DD/MM/YYYY"
                showMonthDropdown
                showYearDropdown
                dropdownMode="select"
                onChange={date => onChange('userDoB', date)}
              />
            </Col>
          </Row> */}
          {showGuardian && (
            <Fragment>
              <Row className="form-row">
                <Col xs={4} className="text-right" style={styles.formLabel}>
                  Guardian Name:
                </Col>
                <Col xs={8}>
                  <input
                    onChange={e => onChange('guardianName', e.target.value)}
                    defaultValue={guardianName}
                  />
                </Col>
              </Row>
              <Row className="form-row">
                <Col xs={4} className="text-right" style={styles.formLabel}>
                  Guardian Relationship:
                </Col>
                <Col xs={8}>
                  <Select
                    onChange={v => onChange('guardianRel', v.value)}
                    options={guardianRelOpts}
                  />
                </Col>
              </Row>
            </Fragment>
          )}
        </Fragment>
      )}
      <hr />
      <Row className="form-row">
        <Col xs={4} className="text-right" style={styles.formLabel}>
          Reason for Visit/Notes:
        </Col>
        <Col xs={8}>
          <input onChange={e => onChange('userQuestions', e.target.value)} />
        </Col>
      </Row>
      {!isScanBooking && (
        <Row className="form-row">
          <Col className="text-right">
            <Button
              color="primary"
              size="sm"
              onClick={handleCalculateFee}
              disabled={loadingCharges}
              style={styles.actionButton}
            >
              {loadingCharges
                ? 'Calculating...'
                : 'Calculate Appointment Charges'}
            </Button>
          </Col>
        </Row>
      )}

      {!isScanBooking && (appointmentFee !== null || chargeError) && (
        <Row className="form-row">
          <Col className="text-right">
            {chargeError ? (
              <p style={styles.errorText}>Error: {chargeError}</p>
            ) : (
              <p style={styles.feeText}>Charges: ₹{appointmentFee}</p>
            )}
          </Col>
        </Row>
      )}

      <Row className="form-row">
        <Col className="text-right">
          <Button
            color="primary"
            size="sm"
            type="submit"
            onClick={e => {
              e.preventDefault();
              onSubmit(bookingData);
            }}
            style={styles.actionButton}
            disabled={loadingCharges}
          >
            Book Slot
          </Button>
        </Col>
      </Row>
      <Row>
        <Col className="error text-left">
          {`Note: If you are booking a Video Consultation, please ask the customer to book it on ${APP_NAME} app.`}
        </Col>
      </Row>
    </React.Fragment>
  );
};

ApptBookingLongForm.propTypes = {
  isNewPatient: PropTypes.bool,
  hasMPI: PropTypes.bool,
  bookingData: PropTypes.object.isRequired,
  onChange: PropTypes.func,
  onSubmit: PropTypes.func,
  hospitalId: PropTypes.number,
  doctorId: PropTypes.number,
  selectedSlot: PropTypes.object,
  procedureName: PropTypes.string,
  isScanBooking: PropTypes.bool
};

export default ApptBookingLongForm;
